import { Widget } from '@typeform/embed-react'
import useTranslation from 'next-translate/useTranslation'

const getTypeFormIdByLang = (lang: Locale) => {
  return {
    en: 'd3ZHi6Ob',
    es: 'blcg12C6',
    fr: 'HgaZDHpY',
    it: 'H4Vy2yV2',
  }[lang]
}

export const ModalTypeForm = () => {
  const { lang } = useTranslation()
  const formId = getTypeFormIdByLang(lang)
  return <Widget inlineOnMobile id={`https://pfa9yx1mzt9.typeform.com/to/${formId}`} style={{ height: '100%' }} />
}
